import React, { Component } from 'react';
import Team_EN from './components/Team_EN';
import Team_NL from './components/Team_NL';
import Team_DE from './components/Team_DE';
import Team_FR from './components/Team_FR';

class Team extends Component {
    render() {
        const { classes, language } = this.props;

        if (!language) {
            return;
        }

        switch(language) {
            case 'nl':
            default:
                return <Team_NL classes={classes}/>
            case 'en':
                return <Team_EN classes={classes}/>
            case 'de':
                return <Team_DE classes={classes}/>
            case 'fr':
                return <Team_FR classes={classes}/>
        };
    }
}
export default Team;
